// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function teamRetrieve(params: { team_id: number }) {
  return http<{
    id: number
    name: string
  }>({
    url: "/api/v1/t/{team_id}/",
    method: "get",
    params,
    pathParamNames: ["team_id"],
  })
}
